import React from "react";

import ClosedTimeCellContent from "../components/ClosedTimeCellContent";

import base from "./base";

import { Column, ColumnId } from ".";

function closedTime({ width, onResize }: Column.Options) {
	return base(
		ColumnId.ClosedTime,
		(item) => <ClosedTimeCellContent item={item} />,
		{
			width,

			onResize: onResize as (
				columnWidth?: number | undefined,
				dataKey?: string | undefined,
			) => void,
		},
	);
}

export default closedTime;
